export function addTableFragmentObjectToTableMap(tableMap, tableFragmentObject) {
  for(const tableId in tableFragmentObject) {
    const tableFragment = tableFragmentObject[tableId];
     addTableFragmentToTableMap(tableMap, tableId, tableFragment);
  }
}

function addTableFragmentToTableMap(tableMap, tableId, tableFragment) {
  const table = getTable(tableMap, tableId);
  addTableFragmentToTable(table, tableFragment);
}

function getTable(tableMap, tableId) {
  const table = tableMap.get(tableId);
  if(table !== undefined) {
    return table;
  }

  const newTable = new Map();
  tableMap.set(tableId, newTable);
  return newTable;
}

function addTableFragmentToTable(table, tableFragment) {
  for(const billingItemId in tableFragment) {
    const billingItem = tableFragment[billingItemId];
    table.set(billingItemId, billingItem);
  }
}

export function findBillingItemInfoProducts(tableMap, item) {
  const billingItemInfo = findBillingItemInfo(tableMap, item);
  if(billingItemInfo === null) {
    return null;
  }
  return billingItemInfo.reward;
}

export function findBillingItemInfo(tableMap, item) {
  const tableId = item.TableId;
  const table = tableMap.get(tableId);
  const billingItemId = item.Service;
  return table.get(billingItemId);
}

//-----------------------------------------------------------------------------

/**
 * @typedef {number} Shop
 */

export const SHOP_STANDARD        = 0;
export const SHOP_MYGAMES_TOPUP   = 1;
export const SHOP_MYGAMES_WEBVIEW = 2;

/**
 * @param {Shop} shopCode
 * @returns {string}
 */
export function getShopName(shopCode) {
  switch(shopCode) {
    case SHOP_STANDARD:        return 'стандартный';
    case SHOP_MYGAMES_TOPUP:   return 'MY.GAMES TopUp';
    case SHOP_MYGAMES_WEBVIEW: return 'MY.GAMES WebView';
  }
  return `Unknown shop code ${shopCode}.`;
}

/**
 * @param {Shop} shopCode
 * @returns {string}
 */
export function getShortShopName(shopCode) {
  switch(shopCode) {
    case SHOP_STANDARD:        return 'ст';
    case SHOP_MYGAMES_TOPUP:   return 'TopUp';
    case SHOP_MYGAMES_WEBVIEW: return 'WebView';
  }
  return `Unknown shop code ${shopCode}.`;
}

// options for component b-form-select
export function getShopOptionsForFilter() {
  const options = getShopOptions();

  const nullOption = {
    value: null,
    text: 'любой',
  };
  options.unshift(nullOption);

  return options;
}

function getShopOptions() {
  const options = [];

  const shopList = getShops();
  for(const shop of shopList) {
    const option = {
      value: shop,
      text: getShopName(shop),
    };
    options.push(option);
  }

  return options;
}

// Магазины перечислены в том порядке,
// в котором они должны быть показаны в инсайдере
// на странице всех платежей в фильтре.
function getShops() {
  return [
    SHOP_STANDARD,
    SHOP_MYGAMES_TOPUP,
    SHOP_MYGAMES_WEBVIEW,
  ];
}

//-----------------------------------------------------------------------------

const SHOP_STRING_CODE__ST      = 'st';
const SHOP_STRING_CODE__TOPUP   = 'topup';
const SHOP_STRING_CODE__WEBVIEW = 'webview';

export function parseShop(str) {
  switch(str) {
    case SHOP_STRING_CODE__ST:      return 0;
    case SHOP_STRING_CODE__TOPUP:   return 1;
    case SHOP_STRING_CODE__WEBVIEW: return 2;
  }
  return null;
}

/**
 * @param {Shop} shopCode
 * @returns {string}
 */
export function getOptionalShopQueryName(shopCode) {
  if(shopCode === null) {
    return null;
  }

  switch(shopCode) {
    case SHOP_STANDARD:        return SHOP_STRING_CODE__ST;
    case SHOP_MYGAMES_TOPUP:   return SHOP_STRING_CODE__TOPUP;
    case SHOP_MYGAMES_WEBVIEW: return SHOP_STRING_CODE__WEBVIEW;
  }

  throw new Error(`Unknown shop code ${shopCode}.`);
}

//-----------------------------------------------------------------------------
// Биллинговая таблица
//-----------------------------------------------------------------------------

/**
 * @param {string} alias
 * @returns {string}
 */
export function convertBillingTableAliasToName(alias) {
  switch(alias) {
    case '@billing/table/generic':          return 'generic';
    case '@billing/table/generic_wealthy':  return 'generic wealthy';
    case '@billing/table/generic_emerging': return 'generic emerging';
  }
  return alias;
}

/**
 * @param {string} alias
 * @returns {string}
 */
export function convertBillingTableAliasToAbbr(alias) {
  switch(alias) {
    case '@billing/table/generic':          return 'G';
    case '@billing/table/generic_wealthy':  return 'GW';
    case '@billing/table/generic_emerging': return 'GE';
  }
  return alias;
}

//function getShortBillingTableAliasByAlias(alias) {
//  const PREFIX = '@billing/table/';
//  if(alias.startsWith(PREFIX)) {
//    return alias.substring(PREFIX.length);
//  }
//  return alias;
//}

//-----------------------------------------------------------------------------
